import { Alert } from '@material-ui/lab';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { MessageContainer } from './styled';
import { errorData, successData } from './data';

export const NotificationMessage = () => {
  const error = useSelector(({ httpOnError }) => httpOnError);
  const success = useSelector(({ httpOnSuccess }) => httpOnSuccess);

  const dispatch = useDispatch();

  const isSuccess = successData.find(
    (item) => item === success[success?.length - 1]?.type,
  );

  const isError = errorData.find((item) => item === error[error?.length - 1]?.type);

  useEffect(() => {
    if (isSuccess) {
      const clearSuccess = setTimeout(() => {
        dispatch(httpRequestsOnSuccessActions.removeSuccess(success[0].type));
      }, 3000);

      return () => {
        clearTimeout(clearSuccess);
      };
    } else if (isError) {
      const clearError = setTimeout(() => {
        dispatch(httpRequestsOnErrorsActions.removeError(error[0].type));
      }, 3000);

      return () => {
        clearTimeout(clearError);
      };
    }
    return null;
  }, [success, error, dispatch]);

  if (isSuccess) {
    return (
      <MessageContainer>
        <Alert variant="filled" severity="success">
          Congratulations! You were successful!
        </Alert>
      </MessageContainer>
    );
  } else if (isError) {
    return (
      <MessageContainer>
        <Alert variant="filled" severity="error">
          Error! Something went wrong!
        </Alert>
      </MessageContainer>
    );
  }
  return null;
};
